import * as React from "react"
import { NumericFormat, NumericFormatProps } from "react-number-format"
import { cn } from "@/lib/utils"

export interface NumericInputProps extends Omit<NumericFormatProps, "value"> {
  value?: number | string
  error?: boolean
}

const NumericInput = React.forwardRef<HTMLInputElement, NumericInputProps>(
  ({ className, value, onChange, onValueChange, error, ...props }, ref) => {
    return (
      <NumericFormat
        getInputRef={ref}
        value={value}
        onValueChange={(values, sourceInfo) => {
          if (onValueChange) {
            onValueChange(values, sourceInfo)
          }
          if (onChange) {
            // Mock a React.ChangeEvent for compatibility with existing forms
            const mockEvent = {
              target: { value: values.value },
              currentTarget: { value: values.value },
            } as React.ChangeEvent<HTMLInputElement>
            onChange(mockEvent)
          }
        }}
        thousandSeparator=","
        decimalSeparator="."
        className={cn(
          "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
          error && "border-destructive focus-visible:ring-destructive",
          className
        )}
        {...props}
      />
    )
  }
)
NumericInput.displayName = "NumericInput"

export { NumericInput }
